<script setup lang="ts">
    /**
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/1915486209
     */
    const props = defineProps<IWidgetProps<MemberSliderData>>();

    const { data, cmsComponentProps, getValueSequence } = useWidget(props);

    const sequence = getValueSequence(data.value);
</script>

<template>
    <org-member-slider
        v-bind="cmsComponentProps"
        :sequence="sequence" />
</template>
